import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'

export type ddmtCredType = never
export const ddmtDocumentTypes = [
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const ddmt: CarrierDef<ddmtCredType> = {
  name: 'Deluxe Delivery Systems',
  scac: 'ddmt',
  credentialTypes: [] as const,
  engineLayers: ['documents'],
  documentTypes: ddmtDocumentTypes,
}
